export type DocLocateTemplate = {
  id: number
  template_name: string
  description: string
  sort_no: number
  is_active: boolean
  is_builtin?: boolean
  field_count?: number
}

export type DocLocateFieldDef = {
  id: number
  field_code: string
  field_name: string
  semantic_queries_json: string[] | null
  keywords_json: string[] | null
  preferred_sections_json: string[] | null
  sort_no: number
  is_active: boolean
}

export type DocLocateImportResult = {
  created: number
  updated: number
  skipped: number
  total_rows: number
  errors: { row: number; message: string }[]
}

export function joinList(items: string[] | null | undefined) {
  return (items || []).join('，')
}

export function splitList(raw: string | undefined) {
  if (!raw?.trim()) return null
  const parts = raw
    .split(/[,，;；\n]+/)
    .map((s) => s.trim())
    .filter(Boolean)
  return parts.length ? parts : null
}
